/**
 * How late a late-to-raise row is: grey up to a week, amber to a month, red beyond.
 *
 * @param days - whole days past the order-by date
 */
export function LateBadge({ days }: { days: number }) {
  const tone = days > 30
    ? 'bg-red-100 text-red-800'
    : days > 7 ? 'bg-amber-100 text-amber-800' : 'bg-slate-100 text-slate-600';
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${tone}`}>
      {days} day{days === 1 ? '' : 's'}
    </span>
  );
}
